/**
 * Canonical action type names for the ClientEngine replay language.
 * Providers/backends MUST use these exact strings.
 */
export const CanonicalActionTypeNames = {
  spinBoundaryStart: "spin_boundary_start",
  spinBoundaryEnd: "spin_boundary_end",
  gridWinHighlight: "grid_win_highlight",
  updateTotalWinMeter: "update_total_win_meter",
  presentScatterState: "present_scatter_state",
  bonusFeatureWon: "bonus_feature_won",
  presentBigWin: "present_big_win",


  presentVisibleMultipliers: "present_visible_multipliers",
  collectGridMultipliers: "collect_grid_multipliers",
  addFeatureMultiplier: "add_feature_multiplier",
  collectFeatureMultiplier: "collect_feature_multiplier",
  presentSpinWinMultiplication: "present_spin_win_multiplication",

  removeSymbolsByMask: "remove_symbols_by_mask",
  needleAward: "needle_award",
  symbolPopValue: "symbol_pop_value",

  // Game-defined action types (e.g. `expanding_wild`, `apply_win_multiplier`,
  // `detonate_chance_symbol`) are NOT canonical — games register handlers for
  // them via ClientEngineConfiguration.plugins.
} as const;
  
/** @public Template API — no user in slot-cannon yet; kept for future titles. */
export type CanonicalActionTypeName =
  typeof CanonicalActionTypeNames[keyof typeof CanonicalActionTypeNames];
const CANONICAL_ACTION_TYPE_NAME_SET: ReadonlySet<string> = new Set(Object.values(CanonicalActionTypeNames));

/** True for an action type the engine validates and ships a canonical handler for. */
export function isCanonicalActionTypeName(actionTypeName: string): boolean {
  return CANONICAL_ACTION_TYPE_NAME_SET.has(actionTypeName);
}
